import "./wdyr";
import { createRoot } from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import { ToastContainer } from "react-toastify";
import "./index.css";
import App from "./App";
import Auth0ProviderWithHistory from "./pages/Auth/Auth0ProviderWithHistory";
import { ThemeProvider } from "@mui/material/styles";
import TagManager, { TagManagerArgs } from "react-gtm-module";
import {
  APP_BACKGROUND_COLOR,
  APP_COLOR,
  darkTheme,
  FONT_FAMILY,
  TEXT_COLOR,
} from "./theme";
import * as Sentry from "@sentry/react";
import { replayIntegration } from "@sentry/react";

const tagManagerArgs: TagManagerArgs = {
  gtmId: "GTM-KBJ86GPC",
};

if (process.env.REACT_APP_ENV === "production") {
  TagManager.initialize(tagManagerArgs);

  Sentry.init({
    dsn: "https://cfded10beb7a4289a90b0db485c8c301@o4504800631259136.ingest.sentry.io/4504800632438784",
    integrations: [
      Sentry.browserTracingIntegration(),
      replayIntegration(),
    ],
    tracesSampleRate: 1.0,
    replaysSessionSampleRate: 0.1,
    replaysOnErrorSampleRate: 1.0,
  });
}

if (document.body && document.body.style) {
  document.body.style.color = TEXT_COLOR;
  document.body.style.backgroundColor = APP_BACKGROUND_COLOR;
  document.body.style.fontFamily = FONT_FAMILY;
}

const rootElement = document.getElementById("root");
if (!rootElement) throw new Error("Failed to find the root element");

const root = createRoot(rootElement);
root.render(
  <ThemeProvider theme={darkTheme}>
    <BrowserRouter>
      <Auth0ProviderWithHistory>
        <App />
        <ToastContainer
          position="top-right"
          autoClose={4000}
          hideProgressBar={false}
          newestOnTop={false}
          closeOnClick
          rtl={false}
          draggable
          toastStyle={{ backgroundColor: APP_COLOR, color: "black" }}
        />
      </Auth0ProviderWithHistory>
    </BrowserRouter>
  </ThemeProvider>
);
